import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const t = i18n.getFixedT(getLocale(), 'common');

export const masterDataApplicationOptions = [
  {
    value: 'SDB_PLANNING',
    label: t('activityPlanningSettings.application_providers.SDB_PLANNING')
  },
  {
    id: 'SDB_ECD',
    label: t('activityPlanningSettings.application_providers.SDB_ECD')
  }
] as Option[];

export const workforceManagementApplicationOptions = [
  {
    value: 'SDB_ACTIVITY_PLANNING',
    label: t(
      'activityPlanningSettings.application_providers.SDB_ACTIVITY_PLANNING'
    )
  },
  {
    value: 'SDB_PLANNING',
    label: t('activityPlanningSettings.application_providers.SDB_PLANNING')
  },
  {
    value: 'INTUS',
    label: t('activityPlanningSettings.application_providers.INTUS')
  },
  {
    value: 'SDB_ECD',
    label: t('activityPlanningSettings.application_providers.SDB_ECD')
  }
] as Option[];
